import React from 'react';
import PartnerByBranchSearchSelect from './PartnerByBranchSearchSelect';

// Simple wrapper that uses companyId+branchId props to show partner dropdown
const PartnerSearchSelect = (props) => {
  return <PartnerByBranchSearchSelect {...props} />;
};

export default PartnerSearchSelect;
